import { FormGroup } from '@angular/forms';
import { CreateDriver, EditDriver } from '../models/driver';

export function mapToAddDriver(driverForm: FormGroup): CreateDriver {

  return {
    firstname: driverForm.value.firstName,
    surname: driverForm.value.surname,
    dateOfBirth: formatDate(driverForm.value.dateOfBirth),
    identificationType: driverForm.value.identificationType,
    countryOfIDIssue: driverForm.value.countryOfIDIssue,
    nationality: driverForm.value.nationality,
    gender: driverForm.value.gender,
    identificationNumber: driverForm.value.nationalIdentification,
    confirmIdentificationNumber: driverForm.value.confirmNationalIdentification,
  };
}

export function formatDate(dateString: Date): string {
  if (!dateString) return '';
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

export function mapToEditDriver(driverForm: FormGroup): EditDriver{
  return {
    firstname: driverForm.value.firstname,
    surname: driverForm.value.surname,
    dateOfBirth: formatDate(driverForm.value.dateOfBirth),
    gender: driverForm.value.gender,
  }
}
